import { ImportedData } from 'lib/imported-data/ImportedData.types';
import Head from 'next/head';
import { sparkleUtils } from './sparkle-utils';

export type ImportedMetaDataProps = {
  data?: ImportedData;
};

export const ImportedMetaData = (props?: ImportedMetaDataProps) => {
  if (!props?.data) return null;

  const canonicalUrl = props.data.canonicalUrl
    ? sparkleUtils.getCanonicalUrl(props.data.canonicalUrl)
    : null;

  return (
    <Head>
      {props.data.browserTitle && (
        <meta property="og:title" content={props.data.browserTitle} key="og:title" />
      )}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} key="url" />}
      {props.data.pageDescription && (
        <meta property="og:description" content={props.data.pageDescription} key="og:description" />
      )}
      {props.data.pageType && <meta property="og:type" content={props.data.pageType} key="type" />}
      {props.data.imageUrl && (
        <meta property="og:image" content={props.data.imageUrl} key="image" />
      )}
      {props.data.imageWidth && (
        <meta property="og:image:width" content={props.data.imageWidth} key="image:width" />
      )}
      {props.data.imageHeight && (
        <meta property="og:image:height" content={props.data.imageHeight} key="image:height" />
      )}
      {props.data.imageType && (
        <meta property="og:image:type" content={props.data.imageType} key="image:type" />
      )}
      {props.data.siteName && (
        <meta property="og:site_name" content={props.data.siteName} key="site_name" />
      )}
      {props.data.publishedTime && (
        <meta
          property="article:published_time"
          content={props.data.publishedTime}
          key="article:published_time"
        />
      )}
      {props.data.modifiedTime && (
        <meta
          property="article:modified_time"
          content={props.data.modifiedTime}
          key="article:modified_time"
        />
      )}
      {props.data.section && (
        <meta property="article:section" content={props.data.section} key="article:section" />
      )}
      {props.data.firstName && (
        <meta
          property="og:profile:first_name"
          content={props.data.firstName}
          key="profile:first_name"
        />
      )}
      {props.data.lastName && (
        <meta
          property="og:profile:last_name"
          content={props.data.lastName}
          key="profile:last_name"
        />
      )}
      {props.data.gender && (
        <meta property="og:profile:gender" content={props.data.gender} key="profile:gender" />
      )}
      {props.data.browserTitle && <title key="title">{props.data.browserTitle}</title>}
      {props.data.pageDescription && (
        <meta name="description" content={props.data.pageDescription} key="description" />
      )}
      {props.data.pageKeywords && (
        <meta name="keywords" content={props.data.pageKeywords} key="keywords" />
      )}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} key="canonical" />}
      {props.data.navigationTitle && (
        <meta name="breadcrumb" content={props.data.navigationTitle} key="breadcrumb" />
      )}
      {props.data.jsonPayload && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: props.data.jsonPayload,
          }}
        />
      )}
    </Head>
  );
};
